// extracted by mini-css-extract-plugin
export default {"header":"List_header__8vrSm","list":"List_list__wS-rC"};